var chunkPrefetchChunkToChildrenMap = {"5090":[6956,6956],"3004":[6956,3771,7604],"403":[6956,3771],"7509":[6956,9886],"9655":[6956,1862],"2717":[6956],"6799":[6956],"4998":[2478],"2709":[6956],"1793":[6956],"4606":[44,8526,9948],"9948":[6956],"3468":[6956],"3736":[6956,3771]};
__webpack_require__.f.prefetch = (chunkId, promises) => {
  Promise.all(promises).then(() => {
    var chunks = chunkPrefetchChunkToChildrenMap[chunkId];
    Array.isArray(chunks) && chunks.map(__webpack_require__.E);
  });
};
